import {useState} from 'react'
import {i18n} from 'common'
import {useIsRtl} from 'store/Store.js'
import {useNavigate} from 'react-router-dom'

const useUnlockContentDialog = () => {
    const isRtl = useIsRtl()
    const [open] = useState(true)
    const navigate = useNavigate()
    const t = (label) => i18n.t(`unlockContent.${label}`)

    const handleClose = () => {
        if (window.history.length > 1) {
            window.history.back()
        } else {
            navigate('/')
        }
    }

    const handleLoginOrRegisterClick = () => {
        navigate('/login')
    }

    return {
        isRtl,
        open,
        handleClose,
        handleLoginOrRegisterClick,
        headerText: t('header'),
        p1Text: t('p1'),
        p2Text: t('p2'),
        loginOrRegisterText: t('loginOrRegister'),
    }
}

export default useUnlockContentDialog
